<div class="gradient-border-card mb-3">
  <!-- Card (NOT clickable) -->
  <div
    v-if="tile"
    class="w-100 bg-transparent shadow-sm p-4 text-start position-relative"
    :class="is_hovered ? 'shadow-lg' : 'shadow-sm'"
    @mouseenter="is_hovered = true"
    @mouseleave="is_hovered = false"
  >

    <!-- Top Row -->
    <div class="d-flex justify-content-between align-items-start mb-3">

      <!-- Icon Box -->
      <div
        class="d-flex justify-content-center align-items-center rounded-4 bg-primary bg-opacity-25 p-3"
        style="width: 60px; height: 60px;"
      >
        <!-- If tile.icon exists, show custom icon -->
        <i 
          v-if="tile.icon"
          :class="tile.icon"
          class="headings-primary fs-4"
        ></i>

        <!-- Otherwise show bootstrap buildings icon -->
        <i 
          v-else 
          class="bi bi-buildings headings-primary fs-3"
        ></i>
      </div>

      <!-- Stat -->
      <div class=" headings-primary">
        {{ tile.stats }}
      </div>

    </div>

    <!-- Title -->
    <h5 class=" headings-primary mb-1">
      {{ tile.title }}
    </h5>

    <!-- Description + Trend on same row -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="text-white-50 text-xxs">
        {{ tile.description }}
      </span>

      <span class="text-success  text-xxs ms-2">
        {{ tile.trend }}
      </span>
    </div>

    <!-- Button aligned right -->
    <div class="d-flex justify-content-end mt-3">
      <button
        class="btn btn-primary btn-sm rounded-3 fw-light text-xxs"
        @click="handleTileClick(tile)"
      >
        {{ getButtonText() }}
      </button>
    </div>

  </div>
</div>
